import GradientCircularProgressbar from "../Components/GradientCircularProgressbar";
import { useLocation, useParams } from "react-router-dom";
import { PROCESS_STEPS, RENEW_STEPS } from "../config/constant";
import { useSelector } from "react-redux";

export default function Header() {
  const {step} = useParams();
  const {pathname} = useLocation();
  const {token, user} = useSelector((state) => state.auth);
  const stepList = (token && user?.id && !pathname.includes("upgrade")) ? RENEW_STEPS : PROCESS_STEPS;

  return (
    <div className="header">
      <div className="pageSteps">
        <span>Step</span> 0{stepList.indexOf(step) + 1}
      </div>
      <GradientCircularProgressbar value={parseInt(((stepList.indexOf(step) +1) / stepList.length) * 100)} />
    </div>
  );
}
